// extracted by mini-css-extract-plugin
module.exports = {"page":"player_page__zVM_m","skeleton_animate":"player_skeleton_animate__kL4N4"};